import debounce from 'lodash.debounce'
import { RoomLastScroll } from '$logic/room-last-scroll/types'
import {
  cachedRoomLastScrolls,
  roomLastScrollDBStorage,
} from '$logic/room-last-scroll/storage'

const debouncedDBRequests: {
  [roomId: string]: (roomId: string, roomLastScroll: RoomLastScroll) => void
} = {}

export async function saveRoomLastScroll(
  roomId: string,
  roomLastScroll: RoomLastScroll,
) {
  cachedRoomLastScrolls[roomId] = roomLastScroll
  if (!debouncedDBRequests[roomId]) {
    debouncedDBRequests[roomId] = debounce(
      (roomId: string, roomLastScroll: RoomLastScroll) => {
        roomLastScrollDBStorage.set(roomId, roomLastScroll)
      },
      3000,
      {},
    )
  }
  debouncedDBRequests[roomId](roomId, roomLastScroll)
}

export function getRoomLastScroll(roomId: string): RoomLastScroll | undefined {
  return cachedRoomLastScrolls[roomId]
}

export async function initializeRoomScrolls() {
  const roomScrolls = await roomLastScrollDBStorage.getAll()
  roomScrolls.forEach(roomScroll => {
    cachedRoomLastScrolls[roomScroll.roomId] = {
      topViewPortMessageIid: roomScroll.topViewPortMessageIid,
      topViewPortMessageId: roomScroll.topViewPortMessageId,
      bottom: roomScroll.bottom,
    }
  })
}
